import React from 'react';
import { LanguageSwitcher as SharedLanguageSwitcher } from '@packages/ui';
import { useLanguageStore } from '../stores/languageStore';

interface LanguageSwitcherProps {
  compact?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ compact = false }) => {
  const { locale, setLocale } = useLanguageStore();

  return <SharedLanguageSwitcher compact={compact} locale={locale} onLocaleChange={setLocale} />;
};

export default LanguageSwitcher;
